module.exports = __webpack_public_path__ + "static/media/f876ad0d220cbf0925e6f36dcd2007f.22c83855.jpg";